{
  "title": "Summon Draconic Spirit (UA)",
  "source": "Unearthed Arcana 78 - Draconic Options",
  "levelAndSchool": "5th-level conjuration",
  "level": 5,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (an art object from a dragon's hoard, worth at least 500 gp)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You call forth a draconic spirit. It manifests in an unoccupied space that you can see within range. This corporeal form uses the Draconic Spirit stat block. When you cast this spell, choose a family of dragon: Chromatic, Gem, or Metallic. The creature resembles a dragon of the chosen family, which determines certain traits in its stat block. The creature disappears when it drops to 0 hit points or when the spell ends.",
    "The creature is an ally to you and your companions. In combat, the creature shares your initiative count, but it takes its turn immediately after yours. It obeys your verbal commands (no action required by you). If you don’t issue any, it takes the Dodge action and uses its move to avoid danger.",
    "At Higher Levels. When you cast this spell using a spell slot of 6th level or higher, use the higher level wherever the spell’s level appears in the stat block.",
    "Draconic Spirit",
    "Large Dragon",
    "Armor Class: 14 + the level of the spell (natural armor)",
    "Hit Points: 50 + 10 for each level of the spell above 5th",
    "Speed: 30 ft., fly 80 ft., swim 30 ft.",
    "STR",
    "DEX",
    "CON",
    "INT",
    "WIS",
    "CHA",
    "19 (+4)",
    "14 (+2)",
    "17 (+3)",
    "10 (+0)",
    "14 (+2)",
    "14 (+2)",
    "Damage Resistances (Chromatic and Metallic only): acid, cold, fire, lightning, poison",
    "Damage Resistances (Gem only): force, necrotic, psychic, radiant, thunder",
    "Condition Immunities: charmed, frightened, poisoned",
    "Senses: blindsight 30 ft., darkvision 60 ft., passive Perception 12",
    "Languages: Draconic, understands the languages you speak",
    "Challenge: —",
    "Proficiency Bonus: equals your bonus",
    "Shared Resistances. When you summon the dragon, choose one of its damage resistances. You have resistance to the chosen damage type until the spell ends.",
    "Actions",
    "Multiattack. The dragon uses its Breath Weapon, and it makes a number of Bite and Claw attacks equal to half the spell's level (rounded down).",
    "Bite and Claw. Melee Weapon Attack: your spell attack modifier to hit, reach 10 ft., one target. Hit: 1d6 + 4 + the spell’s level piercing damage.",
    "Breath Weapon. The dragon exhales a stream of multicolored energy in a 30-foot cone. Each creature in that area must make a Dexterity saving throw, taking 2d6 damage of your choice of a damage type this dragon has resistance to on a failed save, or half as much damage on a successful one."
  ],
  "spellLists": ["druid", "sorcerer", "wizard"]
}
